import { useLoggedInUser } from '~shared-components/hooks/useLoggedInUser'
import {
  getCountryFromSalesOrganization,
  validateCountry,
  validateLanguage,
} from '~shared-components/utils/locale/locale-utils'

import { LangCode } from '../../../api-clients/api-client'
import { SalesGroup } from '../api/sales-groups'
import { getSalesGroupLanguages } from './useAllowedLanguages'
import { useSelectUserLanguage } from './useSelectUserLanguage'

export const useRedirectWithLocale = () => {
  const { user } = useLoggedInUser()

  const {
    dispatchSelectedLanguage,
    isLoading,
    setUserLanguage,
  } = useSelectUserLanguage()

  const redirect = async (salesGroup: SalesGroup) => {
    const userLanguage = validateLanguage(user?.language)
    const userCountry = validateCountry(
      getCountryFromSalesOrganization(salesGroup.salesOrganization),
    )

    const groupLanguages = getSalesGroupLanguages(salesGroup)
    if (groupLanguages.length > 0 && !groupLanguages.includes(userLanguage)) {
      await setUserLanguage({
        country: userCountry,
        language: (groupLanguages[0] as string) as LangCode,
      })
    } else {
      dispatchSelectedLanguage(userLanguage, userCountry)
    }
  }

  return { isLoading, redirect }
}
